export const Text = {
  nav: {
    contact: 'Contact',
    story: 'Our Story',
    blog: 'Blog',
    features: 'Features',
    support: 'Support',
  },
  buttonText: 'Get Toastie',
};
